import axios from 'axios'
import Cookies from 'js-cookie'
import { BASE_URL } from './../../config'

export const userLoginPasswordBased = async (
  loginid,
  password,
  schoolCode,
  login_method,
  login_type,
) => {
  // schoolCode=stage9&loginId=swipetouch&getStudentsByClassSectionSession=1&classId=1&classSecId=1&session=2024-2025
  try {
    return await axios.get(
      `${BASE_URL}/lvalidateNewLogin.php?loginid=${loginid}&loginId=${loginid}&password=${password}&login_type=${login_type}&schoolCode=${schoolCode}&login_method=${login_method}&recipient_no&votp`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while user login', err.message) // Handle errors
  }
}
export const userLoginOtpBased = async (payloadData) => {
  const queryParams = new URLSearchParams()
  Object.entries(payloadData).forEach(([key, value]) => {
    queryParams.append(key, String(value)) // Ensure all values are strings
  })
  const apiUrl = `${BASE_URL}/lvalidateNewLogin.php?${queryParams.toString()}`

  try {
    return await axios.get(apiUrl) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while user otp login', err.message) // Handle errors
  }
}

export function userLogout() {
  Cookies.remove('schoolCode')
  Cookies.remove('loginId')
  Cookies.remove('schoolId')
  Cookies.remove('currentSession')
  Cookies.remove('roleId')
  Cookies.remove('userId')
  Cookies.remove('userType')
  Cookies.remove('userDesignation')
  Cookies.remove('schoolCode')
  Cookies.remove('App_Type')
  Cookies.remove('School_Name')

  // Redirect to the login page
  window.location.href = '#/login'
}

export function inactivityTimeOut() {
  const expiryTime = 120 / (24 * 60) // Convert minutes to days
  const options = { expires: expiryTime }
  Cookies.set('isTimedOut', 'true', options)
  window.location.href = '#/login'
}

export const getUserOtpConfiguration = async (payloadData) => {
  const formData = new FormData()
  Object.keys(payloadData).forEach((key) => {
    formData.append(key, payloadData[key])
  })
  try {
    return await axios.post(`${BASE_URL}/Send_Login_OTP.php`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Adjust header based on API requirements
      },
    }) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting otp configuration', err.message) // Handle errors
  }
}
